import { render, staticRenderFns } from "./InvoiceReceiveTypeCreateEdit.vue?vue&type=template&id=bcebf778&scoped=true&"
import script from "./InvoiceReceiveTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceReceiveTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceReceiveTypeCreateEdit.vue?vue&type=style&index=0&id=bcebf778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcebf778",
  null
  
)

export default component.exports